import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { DataLakeDirectoryModel, GetFileDirectoryByPathQuery, GetDataLakeFileInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_DIRECTORY_BY_PATH = gql`
    query getFileDirectoryByPath($input: GetDataLakeFileInput!) {
        dataLakeFilesAndSubDirectories (input: $input) {
            path
            dataLakeFileModels {
                name
                path
                fileSize
                fileSizeBytes
                lastModifiedTime
                createdTime
            }
            childDirectories {
                name
                path
                lastModifiedTime
                createdTime
                isDeleteDisabled
            }
        }    
    }
`;

export const queryFileDirectoryByPath = async (
    client: ApolloClient<NormalizedCacheObject>,
    directoryPath: string
): Promise<DataLakeDirectoryModel | undefined> => {
    const { data, errors } = await client.query<GetFileDirectoryByPathQuery>({
        variables: {
            input: {
                directoryPath
            }
        },
        query: QUERY_DIRECTORY_BY_PATH,
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    // backend query is written more generic to return an array, 
    // but we only want a single clientPartner
    if (data?.dataLakeFilesAndSubDirectories) {
        return data.dataLakeFilesAndSubDirectories as DataLakeDirectoryModel;
    }
    return undefined;
};